import React  from 'react';
import { Table } from 'rsuite';
import { CompactCell, CompactHeaderCell } from 'Components/Common/Table/CustomCells';
import { ActionCell } from 'Components/Common/Table/CustomMenu';
import { EsatusStack } from 'Components/Common/Detail/EstatusStack';
import { NumericFormat } from 'react-number-format';

const { Column, ColumnGroup } = Table;

export const CustomCCFETable = (props) => {
  const { data, loading, onSelectAction } = props;

  return (
    <Table
      headerHeight={80}
      rowHeight={35}
      data={data}
      loading={loading}
      bordered
      cellBordered
      autoHeight
      affixHeader
      affixHorizontalScrollbar
    >
      {/* <Column width={80} align="center" fixed>
        <CompactHeaderCell>Versión</CompactHeaderCell>
        <CompactCell dataKey="version">{(rowData) => `${rowData.dte.identificacion.version}`}</CompactCell>
      </Column> */}
      <Column width={320} align="center" fixed resizable>
          <CompactHeaderCell>Codigo de generación</CompactHeaderCell>
          <CompactCell dataKey="nite">{(rowData) => `${rowData.dte.identificacion.codigoGeneracion}`}</CompactCell>
        </Column>
      <ColumnGroup align="center" header="Identificacion">
        
        <Column width={150} fixed resizable fullText>
          <CompactHeaderCell>Numero de control</CompactHeaderCell>
          <CompactCell dataKey="numControl">{(rowData) => `${rowData.dte.identificacion.numeroControl}`}</CompactCell>
        </Column>
        <Column width={170}>
          <CompactHeaderCell>Fecha y hora de emisión</CompactHeaderCell>
          <CompactCell dataKey="fecEmi">
            {(rowData) => `${rowData.dte.identificacion.fecEmi} ${rowData.dte.identificacion.horEmi}`}
          </CompactCell>
        </Column>
      </ColumnGroup>
      
      <ColumnGroup align="center" header="Emisor">
        <Column width={140} align="center" colSpan={2}>
          <CompactHeaderCell>NIT</CompactHeaderCell>
          <CompactCell dataKey="nite">{(rowData) => `${rowData.dte.emisor.nit}`}</CompactCell>
        </Column>
        <Column width={100} align="center" colSpan={2}>
          <CompactHeaderCell>NRC</CompactHeaderCell>
          <CompactCell dataKey="nite">{(rowData) => `${rowData.dte.emisor.nrc}`}</CompactCell>
        </Column>
        <Column width={200} align="center" resizable fullText>
          <CompactHeaderCell>Nombre</CompactHeaderCell>
          <CompactCell dataKey="nombree">{(rowData) => `${rowData.dte.emisor.nombre}`}</CompactCell>
        </Column>
      </ColumnGroup>
      <ColumnGroup align="center" header="Receptor">
        <Column width={140} align="center" colSpan={2}>
          <CompactHeaderCell>NIT</CompactHeaderCell>
          <CompactCell dataKey="nite">{(rowData) => `${rowData.dte.receptor.nit}`}</CompactCell>
        </Column>
        <Column width={100} align="center" colSpan={2}>
          <CompactHeaderCell>NRC</CompactHeaderCell>
          <CompactCell dataKey="nite">{(rowData) => `${rowData.dte.receptor.nrc}`}</CompactCell>
        </Column>        
        <Column width={280} align="right" resizable>
          <CompactHeaderCell>Nombre</CompactHeaderCell>
          <CompactCell dataKey="nombrer">{(rowData) => `${rowData.dte.receptor.nombre}`}</CompactCell>
        </Column>
        <Column width={280} align="right" resizable>
          <CompactHeaderCell>Correo</CompactHeaderCell>
          <CompactCell dataKey="correor">{(rowData) => `${rowData.dte.receptor.correo ?? '-'}`}</CompactCell>
        </Column>
        {/* <Column width={110} align="center">
          <CompactHeaderCell>Pais</CompactHeaderCell>
          <CompactCell dataKey="paisr">{(rowData) => `${rowData.dte.receptor.nombrePais}`}</CompactCell>
        </Column> */}
      </ColumnGroup>
      <ColumnGroup align="center" header="Resumen">
        <Column width={200}  align="right" colSpan={2}>
          <CompactHeaderCell>Total (USD)</CompactHeaderCell>
          <CompactCell dataKey="totalPagar">
            {(rowData) => (
              <NumericFormat value={rowData.dte.resumen.totalPagar} displayType={'text'} thousandSeparator={true} prefix={'$'} />
            )}
          </CompactCell>
        </Column>
      </ColumnGroup>

      <Column width={370} align="center" colSpan={2}>
        <CompactHeaderCell>Sello de recibido</CompactHeaderCell>
        <CompactCell dataKey="selloRecibido">
          {(rowData) => (rowData.recepcion ? `${rowData.recepcion.selloRecibido ?? '-'}` : 'Sin sello')}
        </CompactCell>
      </Column>
      <Column width={500} align="left">
        <CompactHeaderCell>Estatus</CompactHeaderCell>
        <CompactCell align="left" dataKey="version">{(rowData) => (
          <EsatusStack estatus={rowData.estatus} validationResult={rowData.validationResult}/>            
        )}</CompactCell>
      </Column>
      <Column width={80} fixed="right" align="center">
        <CompactHeaderCell>Acciones</CompactHeaderCell>
        <ActionCell dataKey="id" onSelect={onSelectAction} />
      </Column>
    </Table>
  );
};
